import GroupActionTypes from 'redux/groups/types';

export const fetchGroups = () => ({
  type: GroupActionTypes.START_FETCH_GROUPS,
});

export const fetchGroupsSuccess = (groups) => ({
  type: GroupActionTypes.FETCH_GROUPS_SUCCESS,
  payload: groups,
});

export const fetchGroupsFailure = (error) => ({
  type: GroupActionTypes.FETCH_GROUPS_FAILURE,
  payload: error,
});

export const fetchGroupItems = () => ({
  type: GroupActionTypes.START_FETCH_GROUP_ITEMS,
});

export const fetchGroupItemssSuccess = (groups) => ({
  type: GroupActionTypes.FETCH_GROUP_ITEMS_SUCCESS,
  payload: groups,
});

export const fetchGroupItemssFailure = (error) => ({
  type: GroupActionTypes.FETCH_GROUP_ITEMS_FAILURE,
  payload: error,
});

export const addGroupItem = (item, cb) => ({
  type: GroupActionTypes.ADD_GROUP_ITEM,
  payload: { item, cb },
});

export const addGroupItemSuccess = (item) => ({
  type: GroupActionTypes.ADD_GROUP_ITEM_SUCCESS,
  payload: item,
});

export const addGroupItemFailure = (item) => ({
  type: GroupActionTypes.ADD_GROUP_ITEM_FAILURE,
  payload: item,
});

export const updateGroup = (data, cb = () => null) => ({
  type: GroupActionTypes.UPDATE_GROUP,
  payload: { data, cb },
});

export const updateGroupSuccess = (payload) => ({
  type: GroupActionTypes.UPDATE_GROUP_SUCCESS,
  payload,
});

export const updateGroupFailure = (payload) => ({
  type: GroupActionTypes.UPDATE_GROUP_FAILURE,
  payload,
});

export const updateGroupItem = (data, cb = () => null) => ({
  type: GroupActionTypes.UPDATE_GROUP_ITEM,
  payload: { data, cb },
});

export const updateGroupItemSuccess = (payload) => ({
  type: GroupActionTypes.UPDATE_GROUP_ITEM_SUCCESS,
  payload,
});

export const updateGroupItemFailure = (payload) => ({
  type: GroupActionTypes.UPDATE_GROUP_ITEM_FAILURE,
  payload,
});

export const deleteGroup = (group, cb) => ({
  type: GroupActionTypes.DELETE_GROUP,
  payload: { group, cb },
});

export const deleteGroupSuccess = (group) => ({
  type: GroupActionTypes.DELETE_GROUP_SUCCESS,
  payload: group,
});

export const deleteGroupFailure = (group) => ({
  type: GroupActionTypes.DELETE_GROUP_FAILURE,
  payload: group,
});

export const deleteGroupItem = (item, cb) => ({
  type: GroupActionTypes.DELETE_GROUP_ITEM,
  payload: { item, cb },
});

export const deleteGroupItemSuccess = (item) => ({
  type: GroupActionTypes.DELETE_GROUP_ITEM_SUCCESS,
  payload: item,
});

export const deleteGroupItemFailure = (item) => ({
  type: GroupActionTypes.DELETE_GROUP_ITEM_FAILURE,
  payload: item,
});

export const addGroup = (item) => ({
  type: GroupActionTypes.ADD_GROUP,
  payload: item,
});

export const addGroupSuccess = (item) => ({
  type: GroupActionTypes.ADD_GROUP_SUCCESS,
  payload: item,
});

export const addGroupFailure = (item) => ({
  type: GroupActionTypes.ADD_GROUP_FAILURE,
  payload: item,
});
